var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',[_c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"col":"12","xs":"12","sm":"12","md":"12","lg":"12","xl":"12"}},[_c('show-main-component',{staticClass:"mt-4",attrs:{"object":_vm.object}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }